export const QUERY_KEYS = {
  TRAINER: 'trainer',
  REQUEST: 'request',
  APPROVED_MEMBERS: 'approved-members',
  ALL_USERS: 'all-users',
  TRACKING_ACTIVITY: 'tracking-activity',
  TRAINER_DETAILS: 'trainer-details',
  SPECIALIZATION: 'specialization',
  ANALYSIS: 'analysis',
  DASHBOARD_COUNTS: 'dashboard-counts',
  DASHBOARD_MEMBERSHIP_TYPES: 'dashboard-membership-types',
  DASHBOARD_MEMBERSHIP_REQUESTS: 'dashboard-membership-requests',
  DASHBOARD_MEMBER_REGISTRATIONS: 'dashboard-member-registrations',
  PROFILE: 'profile',
  AUTH_PROFILE: 'auth-profile'
};
